import Checkbox from '@mui/material/Checkbox';
import type { DataTableColumn } from '@routes-plan/ui';

type Id = string | number;

/**
 * Columna de casillas para elegir filas en `DataTable` (la tabla de la librería no trae selección).
 * El encabezado marca o desmarca todas las filas cargadas.
 */
export function selectionColumn<T>(opts: {
  rows: T[];
  getId: (row: T) => Id;
  selected: Id[];
  onChange: (ids: Id[]) => void;
  selectAllLabel: string;
  selectRowLabel: (row: T) => string;
  disabled?: boolean;
}): DataTableColumn<T> {
  const { rows, getId, selected, onChange, selectAllLabel, selectRowLabel, disabled } = opts;
  const set = new Set(selected.map(String));
  const all = rows.length > 0 && rows.every((r) => set.has(String(getId(r))));
  const some = !all && rows.some((r) => set.has(String(getId(r))));
  return {
    id: '__select',
    header: (
      <Checkbox
        size="small"
        checked={all}
        indeterminate={some}
        disabled={disabled || rows.length === 0}
        onChange={(e) => onChange(e.target.checked ? rows.map(getId) : [])}
        inputProps={{ 'aria-label': selectAllLabel }}
        sx={{ p: 0.5 }}
      />
    ),
    width: 52,
    align: 'center',
    csv: false,
    render: (row) => {
      const id = getId(row);
      const checked = set.has(String(id));
      return (
        <Checkbox
          size="small"
          checked={checked}
          disabled={disabled}
          onClick={(e) => e.stopPropagation()}
          onChange={() => onChange(checked ? selected.filter((x) => String(x) !== String(id)) : [...selected, id])}
          inputProps={{ 'aria-label': selectRowLabel(row) }}
          sx={{ p: 0.5 }}
        />
      );
    },
  };
}
